import type { PriceDaily } from "epsm-api-types/models";

export function getDataForOneSectorChart(
	data: PriceDaily[],
): Record<string, PriceDaily[]> {
	return data.reduce<Record<string, PriceDaily[]>>((acc, item) => {
		const { ticker } = item;
		acc[ticker] = acc[ticker] ? [...acc[ticker], item] : [item];
		return acc;
	}, {});
}
